module.exports = __webpack_public_path__ + "img/presentation-chart-01.7f28b60e.svg";